import React from 'react';
import { string } from 'prop-types';

import SvgIcon from 'ravenjs/lib/SvgIcon';

import { DEFAULT_COLORS } from 'constants/colors';

const ListIcon = ({ viewBox, height, width, fill }) => {
    return (
        <SvgIcon width={width} viewBox={viewBox} height={height} fill="none">
            <path
                fill={fill}
                d="M22.29,6.86H7.42c-.95,0-1.71-.77-1.71-1.71s.77-1.71,1.71-1.71h14.86c.95,0,1.71.77,1.71,1.71s-.77,1.71-1.71,1.71Z"
            />
            <path
                fill={fill}
                d="M22.29,13.71H7.42c-.95,0-1.71-.77-1.71-1.71s.77-1.71,1.71-1.71h14.86c.95,0,1.71.77,1.71,1.71s-.77,1.71-1.71,1.71Z"
            />
            <path
                fill={fill}
                d="M22.29,20.57H7.42c-.95,0-1.71-.77-1.71-1.71s.77-1.71,1.71-1.71h14.86c.95,0,1.71.77,1.71,1.71s-.77,1.71-1.71,1.71Z"
            />
            <path
                fill={fill}
                d="M1.72,6.86c-.95,0-1.72-.77-1.72-1.71s.76-1.71,1.71-1.71h.01c.95,0,1.71.77,1.71,1.71s-.77,1.71-1.71,1.71Z"
            />
            <path
                fill={fill}
                d="M1.72,13.71c-.95,0-1.72-.77-1.72-1.71s.76-1.71,1.71-1.71h.01c.95,0,1.71.77,1.71,1.71s-.77,1.71-1.71,1.71Z"
            />
            <path
                fill={fill}
                d="M1.72,20.57c-.95,0-1.72-.77-1.72-1.71s.76-1.71,1.71-1.71h.01c.95,0,1.71.77,1.71,1.71s-.77,1.71-1.71,1.71Z"
            />
        </SvgIcon>
    );
};

ListIcon.propTypes = {
    viewBox: string,
    height: string,
    width: string,
    fill: string,
};

ListIcon.defaultProps = {
    viewBox: '0 0 24 24',
    height: '24',
    width: '24',
    fill: DEFAULT_COLORS.BLACK,
};

export default ListIcon;
